/**
 * Constants used by the single-host page (mock / UI fixtures).
 *
 * These values are used in development and storybook to render the host
 * details view. They are intentionally simple fixtures and not authoritative
 * production data.
 */

/**
 * @typedef {Object} DealerInfoItem
 * @property {string} label - Field label to display in the UI.
 * @property {string} value - Corresponding field value.
 */

/**
 * @typedef {Object} HostField
 * @property {string} label - Display label for the field.
 * @property {string} value - Display value for the field.
 */

/**
 * @typedef {Object} HostData
 * @property {HostField} id - ID field object containing label and value.
 * @property {HostField} name - Name field object containing label and value.
 * @property {string} image - URL to the host image.
 * @property {DealerInfoItem[]} dealerInfo - Array of dealer/metadata fields.
 */

/**
 * Mock host details used by the single-host view.
 * @type {HostData}
 */
export const HOST_DATA = {
    id: { label: 'ID', value: '1' },
    name: { label: 'Name', value: 'Zone 1 - Peppa Flame Restaurant and Lounge' },
    image: 'https://picsum.photos/200/300',
    dealerInfo: [
        { label: 'Assigned Dealer', value: 'Noob Inc.' },
        { label: 'Created by', value: 'Noob Inc.' },
        { label: 'Notes', value: 'N/A' },
        { label: 'Category', value: 'Music Store' },
        { label: 'Address', value: '900 S Wabash Ave, Chicago, IL 60605' },
    ],
};

/**
 * Business hours display entry used on the host details card.
 * @type {HostField[]}
 */
export const BUSINESS_HOURS = [{ label: 'Business Hours', value: 'Thursday - Open 24 Hours' }];

/**
 * Tag objects used to render tag chips for the host.
 * @typedef {Object} Tag
 * @property {string} label - Tag label shown in the UI.
 * @property {string} color - Hex color used for the tag chip.
 * @type {Tag[]}
 */
export const TAGS = [
    { label: 'SnapPoints', color: '#E53E3E' },
    { label: 'PixelPower', color: '#D69E2E' },
    { label: 'PromoUp', color: '#38A169' },
    { label: 'AdStream', color: '#3182CE' },
    { label: 'CampaignBoost', color: '#805AD5' },
];

/**
 * Quick action options available for the host. Each option maps a human
 * readable `label` to an internal `value` used by action handlers.
 * @type {{label: string, value: string}[]}
 */
export const QUICK_ACTION_OPTIONS = [
    { label: 'Reload', value: 'reload' },
    { label: 'Unassign License', value: 'unassign-license' },
    { label: 'Content Update', value: 'content-update' },
    { label: 'Screenshot', value: 'screenshot' },
    { label: 'Reboot Player', value: 'reboot-player' },
    { label: 'Reboot Pi', value: 'reboot-pi' },
];
